module.exports = __webpack_public_path__ + "img/748.d89ad5b0.png";